/* Draft-theme additions; leaves the shared marquee app configuration unchanged. */
(function(){
 'use strict';
 var script=document.currentScript,src=script&&script.dataset.sandboxLogo,queued=false;
 if(!src)return;
 function sync(){
  queued=false;
  document.querySelectorAll('a[href]').forEach(function(link){
   var url;try{url=new URL(link.href,location.origin);}catch(e){return;}
   if(url.origin===location.origin&&url.pathname==='/pages/infinity-mirror-customizer'){
    url.pathname='/products/custom-infinity-mirror';link.href=url.href;
   }
  });
  document.querySelectorAll('.fab-marquee-content img[alt="Lazada Logo"]').forEach(function(image){
   var item=image.closest('.fab-m-conent');
   if(!item||item.nextElementSibling?.dataset.myxSandbox==='true')return;
   var logo=document.createElement('div');logo.className='fab-m-conent';logo.dataset.myxSandbox='true';
   logo.style.cssText='display:flex;align-items:center;padding:0 22px;flex-shrink:0';
   var img=document.createElement('img');img.src=src;img.alt='Sandbox VR';img.width=128;img.height=24;img.style.cssText='display:block;width:128px;max-width:128px;height:24px;object-fit:contain';
   logo.append(img);item.after(logo);
  });
 }
 new MutationObserver(function(){if(!queued){queued=true;requestAnimationFrame(sync);}}).observe(document.body,{childList:true,subtree:true});
 sync();
})();
